<template>
  <v-container fluid class="pa-0">
    <toolbar title="My Favorites" />

    <v-container class="pt-4">
      <v-row dense>
        <v-col
          v-for="(profile, i) in favorites"
          :key="i"
          cols="12"
          sm="6"
          md="4"
        >
          <ProfileCard
            :profile="profile"
            @view="openProfile"
          />
        </v-col>
      </v-row>

      <div v-if="favorites.length === 0" class="text-center mt-10 grey--text">
        <v-icon size="50" color="primary">mdi-heart-outline</v-icon>
        <div class="primary--text text-h6 font-weight-medium mt-3">No favorites yet</div>
        <div class="primary--text">Start liking profiles to see them here ❤️</div>
      </div>
    </v-container>
  </v-container>
</template>

<script>
import Toolbar from "@/modules/Layout/components/Toolbar.vue";
import ProfileCard from "@/modules/Home/components/ProfileCard.vue";
import profileService from "@/modules/Profile/service.js";

export default {
  components: { Toolbar, ProfileCard },
  data() {
    return {
      favorites: [],
    };
  },
  async created() {
    try {
      const result = await profileService.getFavorites();
      console.log('result', result)
      this.favorites = result.data || [];
    } catch (err) {
      console.error("Error loading favorites:", err);
    }
  },
  methods: {
    openProfile(profile) {
      this.$router.push({
        name: "public-profile-view",
        state: { profileId: profile.id },
        query: { view: "true" },
      });
    },
  },
};
</script>